const TOKEN_KEY = "token";
const USER_KEY = "auth_user";

function emitAuthStateChange(authenticated: boolean) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("auth-state-changed", {
      detail: { authenticated },
    })
  );
}

export function clearAuthToken() {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
  emitAuthStateChange(false);
}
